import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiamondExclamation } from '@fortawesome/sharp-duotone-solid-svg-icons/faDiamondExclamation';
import { faRotateRight } from '@fortawesome/sharp-solid-svg-icons/faRotateRight';
import classNames from 'classnames';

import { DecoratedIcon } from 'ui-components/components/decorated-icon';

import styles from '../app-header.module.less';

type StoreRefreshIconProps = {
  className?: string;
};

export const StoreRefreshIcon = ({ className, ...rest }: StoreRefreshIconProps) => (
  <DecoratedIcon decoration={<FontAwesomeIcon icon={faDiamondExclamation} />} showDecoration {...rest}>
    <FontAwesomeIcon className={classNames(styles['menu-item-icon'], className)} icon={faRotateRight} />
  </DecoratedIcon>
);
